module.exports = __webpack_public_path__ + "blue_photo.png?d986082067d10ba8a2657b7a35618157";